import i from "./index.es119.js";
import m from "./index.es244.js";
import u from "./index.es245.js";
import { getFetch as b } from "./index.es246.js";
import f from "./index.es130.js";
const s = {
  http: m,
  xhr: u,
  fetch: {
    get: b
  }
};
i.forEach(s, (t, n) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: n });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: n });
  }
});
const l = (t) => `- ${t}`, g = (t) => i.isFunction(t) || t === null || t === !1, j = {
  getAdapter: (t, n) => {
    t = i.isArray(t) ? t : [t];
    const { length: p } = t;
    let o, e;
    const c = {};
    for (let r = 0; r < p; r++) {
      o = t[r];
      let a;
      if (e = o, !g(o) && (e = s[(a = String(o)).toLowerCase()], e === void 0))
        throw new f(`Unknown adapter '${a}'`);
      if (e && (i.isFunction(e) || (e = e.get(n))))
        break;
      c[a || "#" + r] = e;
    }
    if (!e) {
      const r = Object.entries(c).map(
        ([d, h]) => `adapter ${d} ` + (h === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = p ? r.length > 1 ? `since :
` + r.map(l).join(`
`) : " " + l(r[0]) : "as no adapter specified";
      throw new f(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return e;
  },
  adapters: s
};
export {
  j as default
};
//# sourceMappingURL=index.es134.js.map
